// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"2cff9df5","442":"ba19f57c","875":"45594fa1","916":"4f0a3f28"}[chunkId] + ".chunk.js";
};